// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 80px 0',
    maxWidth: '1920px',
    width: '100%',
    [theme.breakpoints.down(1800)]: {
      padding: '10px 60px 0',
    },
    [theme.breakpoints.down(1550)]: {
      padding: '10px 50px 0',
    },
    [theme.breakpoints.down(1367)]: {
      padding: '10px 40px 0',
    },
    [theme.breakpoints.down(1025)]: {
      padding: '10px 30px 0',
    },
    [theme.breakpoints.down(769)]: {
      padding: '10px 20px 0',
    },
    [theme.breakpoints.down(500)]: {
      padding: '10px 4px 0',
    },
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoImage: {
    width: '426px',
    height: '100%',
    [theme.breakpoints.down(1800)]: {
      width: 'calc(426px / 1.2)',
    },
    [theme.breakpoints.down(1550)]: {
      width: 'calc(426px / 1.4)',
    },
    [theme.breakpoints.down(1367)]: {
      width: 'calc(426px / 1.5)',
    },
    [theme.breakpoints.down(1025)]: {
      width: 'calc(426px / 1.6)',
    },
    [theme.breakpoints.down(769)]: {
      width: 'calc(426px / 2)',
    },
    [theme.breakpoints.down(426)]: {
      width: 'calc(426px / 3)',
    },
  },
  menuIconContainer: {
    padding: 5,
    marginRight: 20,

    [theme.breakpoints.down(426)]: {
      marginRight: 4,
    },
  },
  menuContainer: {
    marginTop: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  linkContainer: {
    marginLeft: 20,
    marginRight: 20,
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_SECONDARY,
    },
    [theme.breakpoints.down(1800)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    },
    [theme.breakpoints.down(1550)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1367)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
  },
  buttonStyle: {
    marginTop: 24,
    padding: '16px 68px',
    borderRadius: 30,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    backgroundColor: GlobalStyles.color.COLOR_BLACK_GREEN,
    [theme.breakpoints.down(1800)]: {
      marginTop: 22,
      padding: '14px 48px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1550)]: {
      marginTop: 20,
      padding: '12px 36px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1367)]: {
      marginTop: 18,
      padding: '12px 28px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1025)]: {
      marginTop: 16,
      padding: '10px 24px',
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
    [theme.breakpoints.down(769)]: {
      marginTop: 14,
      padding: '8px 16px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
    [theme.breakpoints.down(426)]: {
      marginTop: 8,
      padding: '6px 12px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  loginButtonStyle: {
    marginTop: 24,
    padding: '16px 68px',
    borderRadius: 30,
    borderColor: GlobalStyles.color.COLOR_BLACK_GREY,
    borderWidth: '1px',
    borderStyle: 'solid',
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    [theme.breakpoints.down(1800)]: {
      marginTop: 22,
      padding: '14px 48px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1550)]: {
      marginTop: 20,
      padding: '12px 36px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1367)]: {
      marginTop: 18,
      padding: '12px 28px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1025)]: {
      marginTop: 16,
      padding: '10px 24px',
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
    [theme.breakpoints.down(769)]: {
      marginTop: 14,
      padding: '8px 16px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
    [theme.breakpoints.down(426)]: {
      marginTop: 8,
      padding: '6px 12px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
});

export default styles;
